// extracted by mini-css-extract-plugin
export default {"header":"mantineDrawer_header__bXPUW"};